import styled from "styled-components"
import { device } from "../styles/stylesConfig"
import { memo, useContext, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { allAnimations } from "../effects/Observers"
import { ThemeContext } from "../contexts/theme/ThemeContext"
import { useTranslation } from "react-i18next"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    z-index: 2;
    border-bottom: 1px solid rgba(27, 48, 100, 0.3);
`

const ContentContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 2fr 1fr;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
    
    @media ${device.md} {
        grid-template-columns: 1fr;
    }
`

const DataContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 10vw;
    padding-right: 5vw;
    padding-top: 15vh;
    padding-bottom: 15vh;

    @media ${device.lg} {
        padding-top: 10vh;
        padding-bottom: 10vh;
        padding-left: 5vw;
    }
`

const SecondDivContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding-top: 10vh;
    padding-bottom: 10vh;
    position: relative;

    @media ${device.md} {
        display: none;
    }

`

const ImageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    background-color: #004bb5;
    padding-top: 10vh;
    padding-bottom: 10vh;
    position: relative;

    @media ${device.lg} {
    }

    @media ${device.sm} {
    padding-top: 5vh;
    padding-bottom: 5vh;
    }
`

const Subtitle = styled.p`
    width: 100%;
    color: #2E2D2D;
    font-size: 20px;
    text-align: left;
    z-index: 1;

    span {
        font-weight: bold;
    }

    @media ${device.lg} {
        font-size: 16px;
    }

    @media ${device.md} {
        font-size: 14px;
        text-align: center;
    }

    @media ${device.sm} {
        font-size: 12px;
        width: auto;
    }

`

const Image = styled.img`
    width: 600px;
    height: 600px;
    object-fit: contain;
    transform: scaleX(-1);
    position: absolute;
    margin: auto;
    bottom: 0px;
    right: 0;
    z-index: 1;

    @media ${device.lg} {
        max-height: unset;
        width: 400px;
        height: 400px;
        bottom: 0px;
        left: unset;
        right: 0;
        top: unset;
    }

    @media ${device.md} {
        width: 300px;
        height: 300px;
    }

    @media ${device.sm} {
        width: 150px;
        height: 150px;
        left: unset;
    }
`

const Logo = styled.img`
    width: 300px;
    height: auto;
    object-fit: contain;
    position: absolute;
    margin: auto;
    bottom: 0px;
    top: 0px;
    left: 5vw;
    z-index: 1;

    @media ${device.lg} {
        width: 200px;
    }

    @media ${device.md} {
        width: 150px;
    }

    @media ${device.sm} {
        width: 100px;

    }
`


const ItemsContainer = styled.div`
    width: fit-content;
    display: flex;
    justify-content: center;
    flex-direction: row;
    margin-bottom: 50px;
    gap: 50px;

    @media ${device.md} {
        width: 100%;
        align-items: center;
    }

    @media ${device.md} {
        gap: 0px;
    }
`

const ItemDiv = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 10px;
    
    @media ${device.sm} {

    }
`

const ItemImg = styled.img`
    height: 120px;
    object-fit: contain;
    object-position: center;

    @media ${device.lg} {
        height: 100px;
    }

    @media ${device.md} {
        height: 80px;
    }

    @media ${device.sm} {
        height: 50px;
        min-width: 80px;
    }

    @media ${device.xs} {
        height: 50px;
    }
`

interface Props {
    image: any;
    descriptions: string[];
}

const GlassMainProductSectionComponent = ({ descriptions, image }: Props) => {

    const location = useLocation()

    const {
        theme,
    } = useContext(ThemeContext);

    const { i18n } = useTranslation();

    useEffect(() => {

        allAnimations();

        return () => { allAnimations() };

    }, [location.pathname, i18n.language, theme])

    return (

        <Container>

            <ContentContainer>

                <DataContainer>

                    <ItemsContainer>
                        <ItemDiv className="utils__fade-in-fast-top" >
                            <ItemImg src={require('../images/disvial-negro.webp')} alt="disvial logo" />
                        </ItemDiv>
                        <ItemDiv className="utils__fade-in-fast-top" >
                            <ItemImg src={require('../images/vasa-logo.webp')} alt="vasa logo" />
                        </ItemDiv>
                        <ItemDiv className="utils__fade-in-fast-top" >
                            <ItemImg src={require('../images/climanet-logo.webp')} alt="climanet logo" />
                        </ItemDiv>
                    </ItemsContainer>

                    {descriptions?.map((v) => (<Subtitle className="utils__fade-in-fast-top" key={v} dangerouslySetInnerHTML={{ __html: v }} />))}

                </DataContainer>

                <SecondDivContainer>

                    {/* {image && <Image src={image} alt={'title'} loading="lazy" />} */}

                </SecondDivContainer>

            </ContentContainer>
            <ImageContainer>

                {image && <Image src={image} alt={'title'} loading="lazy" />}

                <Logo src={require('../images/logo-blanco.png')} alt={'title'} loading="lazy" />

            </ImageContainer>

        </Container>

    )
}

const GlassMainProductSection = memo(GlassMainProductSectionComponent);

export default GlassMainProductSection;